module.exports = __webpack_public_path__ + "img/blue_094.ebcc08d6.png";